var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[(['/resource', '/repair', '/reslink'].indexOf(_vm.$route.path)==-1)?_c('div',{staticClass:"head-div"},[_c('Header')],1):_vm._e(),_c('div',{attrs:{"id":"main-div"}},[_c('router-view')],1),(['/resource', '/repair', '/reslink'].indexOf(_vm.$route.path)==-1)?_c('div',[_c('Footer')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }